import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/style.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import {getRequest} from "@/api/api";
import VueLazyload from 'vue-lazyload'

import VueVideoPlayer from 'vue-video-player'

import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VueVideoPlayer);
// 配置项
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('@/assets/images/localLazy/fff.jpg'),
  loading: require('@/assets/images/localLazy/loading.svg'),
  attempt: 1
})
Vue.use(ElementUI);
Vue.prototype.getRequest = getRequest;


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

